import {throttle} from 'es-toolkit';

const DEFAULT_MIN_WIDTH = '300px';
const THROTTLE_ON_MOVE_MS = 20;

export class HtmlSplitter {

    // Default width for the right pane
    private isResizing = false;
    private startX: number = 0;
    private startWidth: number = 0;
    private readonly minWidth: number = 400;

    private throttledDoApplyMouseMove = throttle(this.doApplyMouseMove.bind(this), THROTTLE_ON_MOVE_MS);

    constructor(public gutterElement: HTMLElement, public resizableElement: HTMLElement) {
        const minWidthComputed = window.getComputedStyle(this.resizableElement).minWidth;
        const minWidthPx = /px$/.test(minWidthComputed) ? minWidthComputed : DEFAULT_MIN_WIDTH;
        this.minWidth = parseInt(minWidthPx, 10);
    }

    onResizeStart(event: MouseEvent): void {
        this.isResizing = true;
        this.startX = event.clientX;
        this.startWidth = this.resizableElement.clientWidth;

        // Prevent default text selection during drag
        event.preventDefault();
    }

    onMouseMove(event: MouseEvent): void {
        if (!this.isResizing) return;
        this.throttledDoApplyMouseMove(event);
    }

    private doApplyMouseMove(event: MouseEvent) {
        // Calculate delta (Move left = increase width, Move right = decrease width)
        // Since the resizable panel is on the RIGHT, dragging left increases its size.
        const offset = this.startX - event.clientX;
        const newWidth = Math.max(this.minWidth, this.startWidth + offset);
        console.log(`New width: ${newWidth}px`);
        this.resizableElement.style.width = `${newWidth}px`;
    }

    onMouseUp(): void {
        this.isResizing = false;
    }
}
